export { default as Img200 } from './processed/200/Double-Shot-at-Love.jpg';
export { default as Img400 } from './processed/400/Double-Shot-at-Love.jpg';
export { default as Imgthumb } from './processed/thumb/Double-Shot-at-Love.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Double-Shot-at-Love.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Double-Shot-at-Love.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      212,
      43,
      45
    ],
    "_population": 979,
    "_hsl": [
      0.9980276134122289,
      0.6627450980392158,
      0.5
    ]
  },
  "LightVibrant": {
    "_rgb": [
      244,
      170,
      151
    ],
    "_population": 120,
    "_hsl": [
      0.034050179211469515,
      0.8086956521739134,
      0.7745098039215687
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      158,
      29,
      33
    ],
    "_population": 362,
    "_hsl": [
      0.9948320413436692,
      0.6898395721925132,
      0.3666666666666667
    ]
  },
  "Muted": {
    "_rgb": [
      173,
      120,
      92
    ],
    "_population": 293,
    "_hsl": [
      0.05761316872427983,
      0.33061224489795926,
      0.5196078431372549
    ]
  },
  "LightMuted": {
    "_rgb": [
      193,
      145,
      120
    ],
    "_population": 167,
    "_hsl": [
      0.05707762557077625,
      0.3705583756345177,
      0.6137254901960785
    ]
  },
  "DarkMuted": {
    "_rgb": [
      82,
      51,
      42
    ],
    "_population": 1232,
    "_hsl": [
      0.03750000000000001,
      0.32258064516129037,
      0.2431372549019608
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Double-Shot-at-Love.js